import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { useTranslation } from 'react-i18next'

import TableBackdrop from '../../../TableUI/TableBackdrop'
import { Chip, Typography } from '@mui/material'
//import CurrencyValue from '../../../TableUI/CurrencyValue'


const styles = () => ({
    root: {
        width: '100%',
        overflowX: "auto",
    }, table: {
        minWidth: 650,
    }
})

export default function FileUploadTable({
    data,
    loading = false
}) {
    const { t } = useTranslation()

    return (
        <>
            <TableContainer className={styles.root}>
                <Table className={styles.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('Rut')}</TableCell>
                            <TableCell>{t('ID')}</TableCell>
                            <TableCell>{t('Full name')}</TableCell>
                            <TableCell align="right">{t('Amount')}</TableCell>
                            <TableCell align="right">{t('Acount number')}</TableCell>
                            <TableCell align="center">{t('Status')}</TableCell>
                            <TableCell align="center">{t('Motive')}</TableCell>
                            <TableCell>&nbsp;</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && data.length ? data.map((row, idx) => (
                            <TableRow
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <Typography>{row['rut']}</Typography>
                                </TableCell>
                                <TableCell>{row['id']}</TableCell>
                                <TableCell>{row['nombre']}</TableCell>
                                <TableCell align="right">
                                    {row['monto_abono']}
                                </TableCell>
                                <TableCell align="right">
                                    {row['n_cuenta']}
                                </TableCell>
                                <TableCell align="center">
                                    {row['estado_abono'] === 'Pagado' && (<Chip label={row['estado_abono'].toUpperCase()} color="success" variant="outlined" />)}
                                    {row['estado_abono'] === 'Rechazado' && (<Chip label={row['estado_abono'].toUpperCase()} color="error" variant="outlined" />)}
                                </TableCell>
                                <TableCell>
                                    {row['estado_abono'] === 'Rechazado' && (
                                        <Typography>{row['motivo']}</Typography>
                                    )}
                                    {!row['id'] && (
                                        <Typography>NO SE HA ENCONTRADO REGISTRO</Typography>
                                    )}
                                </TableCell>
                            </TableRow>
                        )) : <TableRow>
                            {
                                loading ? <TableBackdrop open={loading} /> : <TableCell sx={{ textAlign: 'center' }} colSpan={100}>{t('No records found')}</TableCell>
                            }
                        </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}
